export default () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
